import { useState } from 'react';
import EndOfDayGenel from '../components/EndOfDayGenel';
import { KasaOzetiPaper, MobileReportStatus, useMobileDailyReport } from './MobileKasaOzeti';
import './MobileGunSonu.css';

// iOS admin uygulamasının WebView'da açtığı Gün Sonu raporu:
//   /mobile/gun-sonu?store_id=<id>&date=YYYY-MM-DD
// Web'deki Gün Sonu modalının "Genel" ve "Kasa Özeti" sekmeleriyle aynı bileşenleri kullanır;
// yalnızca yerleşim telefona göre düzenlenir (MobileGunSonu.css). Ortak altyapı: MobileKasaOzeti.js
function MobileGunSonu() {
  const { report, status, error, retry } = useMobileDailyReport({ title: 'Gün Sonu Raporu', forceLight: true });
  const [tab, setTab] = useState('genel');
  const [expandedPaymentType, setExpandedPaymentType] = useState(null);
  const [expandedCashiers, setExpandedCashiers] = useState({});
  const [eodCashierFilter, setEodCashierFilter] = useState([]);
  const [expandedSales, setExpandedSales] = useState({});
  const refreshing = status === 'loading';

  return (
    <div className="mko-page meod-page" aria-busy={refreshing}>
      <div className="meod-tabs-bar">
        <div className="meod-tabs" role="tablist">
          <button type="button" role="tab" aria-selected={tab === 'genel'} className={`meod-tab${tab === 'genel' ? ' active' : ''}`} onClick={() => setTab('genel')}>Genel</button>
          <button type="button" role="tab" aria-selected={tab === 'kasaOzeti'} className={`meod-tab${tab === 'kasaOzeti' ? ' active' : ''}`} onClick={() => setTab('kasaOzeti')}>Kasa Özeti</button>
        </div>
      </div>

      <MobileReportStatus status={status} error={error} hasReport={!!report} onRetry={retry} />

      {report && tab === 'genel' && (
        <div className={`meod-genel eod-report${refreshing ? ' is-refreshing' : ''}`}>
          <EndOfDayGenel
            report={report.data}
            expandedPaymentType={expandedPaymentType}
            setExpandedPaymentType={setExpandedPaymentType}
            expandedCashiers={expandedCashiers}
            setExpandedCashiers={setExpandedCashiers}
            eodCashierFilter={eodCashierFilter}
            setEodCashierFilter={setEodCashierFilter}
            expandedSales={expandedSales}
            setExpandedSales={setExpandedSales}
          />
        </div>
      )}

      {report && tab === 'kasaOzeti' && <KasaOzetiPaper report={report} refreshing={refreshing} />}
    </div>
  );
}

export default MobileGunSonu;
